import { useContext } from "react";

import { CorbanContext } from "@contexts/Corban";

export const useCorban = () => {
  return useContext(CorbanContext);
};
